import { status } from '../../config.ts'
import { drawsPage1, drawDetail } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'GET',
    path: '/campaign-draws?limit=20',
    reply: async () => {
      await wait()
      return [status.ok, drawsPage1]
    }
  },
  {
    method: 'GET',
    path: '/campaign-draws/1',
    reply: async () => {
      await wait()
      return [status.ok, drawDetail]
    }
  },
  {
    method: 'POST',
    path: '/campaign-draws',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'PUT',
    path: '/campaign-draws/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  },
  {
    method: 'DELETE',
    path: '/campaign-draws/1',
    reply: async () => {
      await wait()
      return [status.ok]
    }
  }
]
